import { Component, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { AccountService } from '../../../services/account.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { AccountGridResponse, Accounts, gridPageRequest } from '../../../model/common/common.model';


@Component({
  selector: 'app-unit-glaccounts',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './unit-glaccounts.component.html',
  styleUrl: './unit-glaccounts.component.scss'
})
export class UnitGlaccountsComponent {

  isActive: boolean = false;
  searchKey: any;

  constructor(private AccountService: AccountService, public ref: DynamicDialogRef) { }

  @ViewChild('dt1') dt1: Table | undefined;
  Accounts: Accounts[] = [];
  start: number = 0;
  rowsPerPage: number = 5;


  result: AccountGridResponse = {
    account: [],
    totalRecords: 0
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }

  ngOnInit(): void {
    this.getAccounts();
    this.searchEffect();

  }


  getAccounts() {
    this.AccountService.getAllAccounts(this.pageRequest).subscribe({
      next: (data: any) => {
        this.result = data as AccountGridResponse;
      },
      error: error => {
        console.log()
      }
    });
  }



  editAccount(data?: any) {
    if (data) {
    } else {
    }
  }

  loadAccounts(event: any) {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getAccounts();
  }

  searchAccount() {
    if (!this.searchKey) {
      return;
    }
    this.AccountService.searchAccount(this.searchKey).subscribe(
      (data: any) => {
        if (data) {
          this.result.account = data;
          if (this.dt1) {
            this.dt1.first = 0;
          }
          this.searchKey = undefined;
        } else {
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
    }
    this.getAccounts();
  }

  SelectOption(event: any) {
    if (event?.data) {
      this.ref.close(event?.data);
    } else {
      this.ref.close(event);
    }
  }


  placeholder: string = 'Search By ';
  private messages: string[] = ['Account Code',	'Account Name',	'Account Type',	'Account Group'];    
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

}
